var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent"},[_c('v-img',{ref:"image",class:_vm.imgClass,attrs:{"src":_vm.srcComputed,"lazy-src":_vm.lazySrc,"alt":_vm.alt,"width":"100%","contain":false,"aspect-ratio":_vm.aspectRatio}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }